import styled, { css } from 'styled-components';

import { colorsPalettes, rgba, setFontVariant } from '@similarweb/styles';

const WIDTH = '16px';

export const StyledRadioLabelText = styled.span`
  margin-left: 10px;
  ${setFontVariant('body2')};
  color: ${rgba(colorsPalettes.carbon[500], 0.8)};
  transition: opacity 300ms ease;
`;

export const StyledRadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

export const StyledRadioBorder = styled.span`
  position: relative;
  box-sizing: content-box;
  width: ${WIDTH};
  height: ${WIDTH};
  border-radius: 50%;
  border: solid 2px ${colorsPalettes.carbon[200]};
  background-color: transparent;
  box-shadow: 0 0 0 0 transparent;
  transition: box-shadow 300ms ease-in-out;
  &:after {
    content: '';
    position: absolute;
    width: ${WIDTH};
    height: ${WIDTH};
    border-radius: 50%;
    background: ${colorsPalettes.blue[400]};
    transform: scale(0);
    transition: transform 300ms ease;
  }
`;

const getRadioBorderStyles = (color: string) => css`
  ${StyledRadioBorder} {
    background-color: ${color};
    box-shadow: 0 0 0 8px ${color};
    transition: box-shadow 300ms ease-in-out;
  }
`;

export const StyledRadioContainer = styled.label<{ selected?: boolean; disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  cursor: pointer;
  &:hover {
    ${getRadioBorderStyles(rgba(colorsPalettes.carbon[500], 0.05))}
  }
  &:focus,
  &:focus-within,
  &:active {
    ${getRadioBorderStyles(rgba(colorsPalettes.carbon[500], 0.1))}
  }
  label {
    cursor: pointer;
  }
  ${({ selected }) =>
    selected
      ? css`
          ${StyledRadioBorder}:after {
            transform: scale(0.6);
          }
        `
      : css`
          &:hover {
            ${StyledRadioBorder}:after {
              opacity: 0.4;
            }
          }
        `}
  ${({ disabled }) =>
    disabled
      ? css`
          label {
            cursor: not-allowed;
          }
          cursor: not-allowed;
          pointer-events: none;
          opacity: 0.4;
          ${StyledRadioBorder}:after {
            background: ${colorsPalettes.carbon[300]};
          }
        `
      : css`
          &:hover {
            ${StyledRadioBorder}:after {
              transform: scale(0.6);
            }
          }
        `}
`;
